import http from "@/utils/http";


export const CompanyApi = {

    updateSystemVersionType(systemVersionType) {
        return http.get(`/server/umsCompany/updateSystemVersionType/${systemVersionType}`)
    },
    // 更新是否开启访客人脸识别
    updateEnabledFace(enabledFace){
        return http.get(`/server/umsCompany/updateEnabledFace/${enabledFace}`)
    },
    companySetting(data) {
        return http.post(`/server/umsCompany/setting`, data)
    },
    queryCurrentCompany() {
        return http.get(`/server/umsCompany/queryCurrentCompany`)
    },
}